import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent {
  @Input() selectedItem: any;
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  public isPopupOpen: boolean = false;
  showShadow = false;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
  }
  
  handleClick(event: any) {
    const isSliderClicked = event.target.closest('.slider');
    if (this.isPopupOpen) {
      if (this.elementRef.nativeElement.contains(event.target) || event.target === this.elementRef.nativeElement) {
        if (!isSliderClicked) {
          this.closePopup();
        }
      }
    }
  }

  onConfirm() {
    this.confirm.emit();
    this.isPopupOpen = false;
    this.showShadow = false;
  }

  onCancel() {
    this.cancel.emit();
    document.body.classList.remove('menu-open');
  }

  openTab() {
    this.isPopupOpen = true;
    this.showShadow = true;
    document.body.classList.add('menu-open');
  }
  closePopup() {
    console.log("CLOSE")
    this.isPopupOpen = false;
    this.showShadow = false;

  }

  changeState(id?: number) {
    this.isPopupOpen = true;
    this.showShadow = true;

  }

}
